import { GridDefaultCellTemplates } from '../../../components/components/Grid/grid-template';
import { SelectOption } from '../../../shared/components/input';
import { Button } from 'primereact/button';
import React from 'react';
import { CommonUtility } from '../../../Services/CommonUtility';
import * as constant from '../../../shared/util/constant';
import { AgencyMasterCodesLabels as agcLabel } from '../../../shared/util/label';

export default class AgencyMasterCodesService {
    private ActionColumn = {
        CellTemplate: (cell: any) => {
            const disableButton = !!cell?.row?.original?.isGridInEditMode;
            return (
                <div className="agent-code-action-btns">
                    <Button
                        icon="bi bi-pencil"
                        onClick={() => {
                            if (!disableButton)
                                cell.column.CellEditTemplateParameters?.cellClickHandler(cell.row.original, cell.column, 'edit_row');
                        }}
                        disabled={disableButton}
                        size="small"
                        tooltip={agcLabel.BTN_EDIT}
                        rounded
                        text
                        className="agent-code-action-btn"
                    />
                    <Button
                        icon="bi bi-trash"
                        onClick={() => {
                            if (!disableButton)
                                cell.column.CellEditTemplateParameters?.cellClickHandler(cell.row.original, cell.column, 'delete_row');
                        }}
                        disabled={disableButton}
                        size="small"
                        tooltip={agcLabel.BTN_DELETE}
                        severity="danger"
                        rounded
                        text
                        className="agent-code-action-btn"
                    />
                </div>
            );
        },
    };

    public getGridColumns = (
        onEditingCellDataChange: (row: any, column: any, value: any, additionalInfo: any) => void,
        onOriginalRowDataChange: (row: any, fieldName: string, value: any) => void,
        cellClickHandler: (row: any, column: any, additionalData: any) => void,
        agencyOptions: SelectOption[],
        lobOptions: SelectOption[],
        marketTypeOptions: SelectOption[],
        stateOptions: SelectOption[]
    ): any[] => {
        return [
            {
                Header: agcLabel.ACTIONS,
                accessor: 'enableGridRowEditing',
                hideColumnFilter: true,
                headerClassName: 'sticky-col sticky-col-header',
                cellClassName: 'sticky-col',
                Cell: (cell: any) => {
                    if (cell.row?.original?.enableGridRowEditing)
                        return GridDefaultCellTemplates.SaveRowGridColumn.CellTemplate(cell);
                    return this.ActionColumn.CellTemplate(cell);
                },
                CellEditTemplateParameters: { cellClickHandler },
                CellEditTDProperties: { className: 'grd-edit-cell-td sticky-col' },
                width: 90,
            },
            {
                Header: agcLabel.AGENCY,
                accessor: 'agencyDescr',
                fieldName: 'agencyId',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: (cell: any) => (
                    <div><span title={cell.row?.original?.agencyDescr}>{cell.row?.original?.agencyDescr}</span></div>
                ),
                CellEditTemplate: GridDefaultCellTemplates.SelectFieldGridColumn.CellTemplate,
                CellEditTemplateParameters: {
                    options: agencyOptions,
                    cellDataChangeHandler: onEditingCellDataChange,
                    dropDownIconClassName: 'grd-edit-cell-select-icon',
                    selectMainDivInvalidClassName: 'custom-dropdown--error-select-div',
                },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.SelectFieldGridColumn.ErrorHandler,
                CellEditTDProperties: { className: 'grd-edit-cell-td' },
                width: 200,
            },
            {
                Header: agcLabel.LINE_OF_BUSINESS,
                accessor: 'lobDescr',
                fieldName: 'lobId',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: (cell: any) => (
                    <div><span title={cell.row?.original?.lobDescr}>{cell.row?.original?.lobDescr}</span></div>
                ),
                CellEditTemplate: GridDefaultCellTemplates.SelectFieldGridColumn.CellTemplate,
                CellEditTemplateParameters: {
                    options: lobOptions,
                    cellDataChangeHandler: onEditingCellDataChange,
                    dropDownIconClassName: 'grd-edit-cell-select-icon',
                    selectMainDivInvalidClassName: 'custom-dropdown--error-select-div',
                },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.SelectFieldGridColumn.ErrorHandler,
                CellEditTDProperties: { className: 'grd-edit-cell-td' },
                width: 180,
            },
            {
                Header: agcLabel.AGENCY_CODE,
                accessor: 'agentCode',
                fieldName: 'agentCode',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: (cell: any) => (
                    <div><span title={cell.row?.original?.agentCode}>{cell.row?.original?.agentCode}</span></div>
                ),
                CellEditTemplate: GridDefaultCellTemplates.TextInputGridColumn.CellTemplate,
                CellEditTemplateParameters: { cellDataChangeHandler: onEditingCellDataChange, maxLength: 50 },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.TextInputGridColumn.ErrorHandler,
                CellEditTDProperties: { className: 'grd-edit-cell-td' },
                width: 140,
            },
            {
                Header: agcLabel.MARKET_TYPE,
                accessor: 'marketTypeDescr',
                fieldName: 'marketTypeId',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: (cell: any) => (
                    <div><span title={cell.row?.original?.marketTypeDescr}>{cell.row?.original?.marketTypeDescr}</span></div>
                ),
                CellEditTemplate: GridDefaultCellTemplates.SelectFieldGridColumn.CellTemplate,
                CellEditTemplateParameters: {
                    options: marketTypeOptions,
                    cellDataChangeHandler: onEditingCellDataChange,
                    dropDownIconClassName: 'grd-edit-cell-select-icon',
                },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.SelectFieldGridColumn.ErrorHandler,
                CellEditTDProperties: { className: 'grd-edit-cell-td' },
                width: 160,
            },
            {
                Header: agcLabel.EFFECTIVE_DATE,
                accessor: 'effDateDisplay',
                fieldName: 'effDate',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: (cell: any) => (
                    <div><span title={cell.row?.original?.effDateDisplay}>{cell.row?.original?.effDateDisplay}</span></div>
                ),
                CellEditTemplate: GridDefaultCellTemplates.DateFieldGridColumn.CellTemplate,
                CellEditTemplateParameters: { cellDataChangeHandler: onEditingCellDataChange, isPopperTop: true, popperClassName: 'agent-code-date-popper', popperProps: { strategy: 'fixed' } },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.DateFieldGridColumn.ErrorHandler,
                CellEditTDProperties: { className: 'grd-edit-cell-td agent-code-date-td' },
                width: 160,
            },
            {
                Header: agcLabel.PROPERTY_STATE,
                accessor: 'propertyState',
                fieldName: 'propertyState',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: (cell: any) => (
                    <div><span title={cell.row?.original?.propertyState}>{cell.row?.original?.propertyState}</span></div>
                ),
                CellEditTemplate: GridDefaultCellTemplates.SelectFieldGridColumn.CellTemplate,
                CellEditTemplateParameters: {
                    options: stateOptions,
                    cellDataChangeHandler: onEditingCellDataChange,
                    dropDownIconClassName: 'grd-edit-cell-select-icon',
                },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.SelectFieldGridColumn.ErrorHandler,
                CellEditTDProperties: { className: 'grd-edit-cell-td' },
                width: 140,
            },
            {
                Header: agcLabel.NOTE,
                accessor: 'noteShort',
                fieldName: 'note',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: (cell: any) => {
                    const originalRow = cell.row?.original;
                    const isExpanded = !!originalRow?.isNoteExpanded;
                    const fullNote = originalRow?.note || '';
                    const shortNote = originalRow?.noteShort || '';
                    const hasMore = fullNote.length > shortNote.length;
                    const textToShow = isExpanded ? fullNote : shortNote;
                    return (
                        <div className="agent-code-note-cell">
                            <span title={fullNote}>{textToShow}</span>
                            {(hasMore || isExpanded) && (
                                <span
                                    className="btn btn-link p-0 text-primary text-decoration-none agent-code-note-toggle"
                                    onClick={() => onOriginalRowDataChange(originalRow, 'isNoteExpanded', !isExpanded)}
                                >
                                    {isExpanded ? ' ...less' : ' more'}
                                </span>
                            )}
                        </div>
                    );
                },
                CellEditTemplate: GridDefaultCellTemplates.TextFieldGridColumn.CellTemplate,
                CellEditTemplateParameters: { cellDataChangeHandler: onEditingCellDataChange, maxLength: 100 },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.TextFieldGridColumn.ErrorHandler,
                CellEditTDProperties: { className: 'grd-edit-cell-td' },
                width: 250,
            },
        ];
    };

    public getNewRow = (carrierId: string): any => {
        const base: any = {
            id: constant.DEFAULT_GUID,
            carrierId,
            agencyId: '',
            agencyDescr: '',
            lobId: '',
            lobDescr: '',
            agentCode: '',
            marketTypeId: null,
            marketTypeDescr: null,
            effDate: null,
            effDateDisplay: '',
            propertyState: null,
            note: null,
            noteShort: '',
            isNoteExpanded: false,
            enableGridRowEditing: true,
            isGridInEditMode: false,
        };
        base.editingRow = { ...base };
        return base;
    };

    public enrichRow = (row: any): void => {
        row.effDateDisplay = row.effDate ? CommonUtility.formateDate(new Date(row.effDate)) : '';
        row.noteShort = row.note || '';
        if (row.note && row.note.length > 40) {
            row.noteShort = CommonUtility.truncateString(row.note, 40);
        }
        row.isNoteExpanded = false;
        row.enableGridRowEditing = false;
        row.isGridInEditMode = false;
    };

    public validateRow = (originalRow: any): any => {
        const er = originalRow.editingRow;
        const errors: any = {};
        if (!er?.agencyId?.trim())
            errors['agencyId'] = { isValid: false, warningText: constant.FIELD_CANNOT_BE_BLANK };
        if (!er?.agentCode?.trim())
            errors['agentCode'] = { isValid: false, warningText: constant.FIELD_CANNOT_BE_BLANK };
        return errors;
    };
}
